import { email, uid, uid as uidFunc } from '@/firebase'
import { fetchCalendarTimeZone } from '@/helpers/apiClient'
import { browserTimeZone } from '@/helpers/browserTimeZone'
import { UserPublicProfile } from '@/helpers/fs/userPublicProfile'
import { FSUserPublicProfile } from '@WombatTechnology/nitte-time-lib'
import { DocumentReference } from 'firebase/firestore'
import { defineStore } from 'pinia'

// State
type State = {
  userPublicProfile: FSUserPublicProfile | null
  userPublicProfileRef: DocumentReference | null
  calendarTimeZone: string | null
}

export const useUserStore = defineStore('user', {
  state: (): State => {
    return {
      userPublicProfile: null,
      userPublicProfileRef: null,
      calendarTimeZone: browserTimeZone() // NOTE: 取得できるまではブラウザのものを入れておく
    }
  },
  actions: {
    async setup() {
      const uid = uidFunc()!
      this.sync('userPublicProfile', UserPublicProfile.doc(uid))
      this.calendarTimeZone = (await fetchCalendarTimeZone(uid)).timeZone
    }
  },
  getters: {
    isCalendarScopeAuthorized(state) {
      return UserPublicProfile.isCalendarScopeAuthorized(
        state.userPublicProfile
      )
    },
    isRoomAvailable(state) {
      return UserPublicProfile.isRoomAvailable(state.userPublicProfile)
    },
    userName(state): string | null {
      return state.userPublicProfile?.name ?? null
    },
    companyName(state): string | null {
      return state.userPublicProfile?.companyName ?? null
    },
    userId(state) {
      return state.userPublicProfile?.userId
    },
    accountType(state) {
      return state.userPublicProfile?.accountType
    },
    // 以下stateに依存しないが他のgetterとまとめて書けると楽なのでこうしておく
    userEmail() {
      return email()
    },
    uid() {
      return uid()
    },
    isGoogleAccount(state) {
      return state.userPublicProfile?.accountType === 'google'
    },
    isMsAccount(state) {
      return state.userPublicProfile?.accountType === 'ms'
    }
  }
})
